var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRouter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.863 8.895C6.456 9.707 8 11.27 8 14.219m0 0v.813m0-.813c0-2.95 1.544-4.512 4.138-5.324M8 14.219V4.25m-1.468 0a.346.346 0 0 1-.298-.52l1.469-2.604a.346.346 0 0 1 .595 0l1.468 2.603a.346.346 0 0 1-.298.522zM4.508 7.338a.347.347 0 0 0-.369-.475l-2.875.404a.346.346 0 0 0-.228.551l1.745 2.317a.348.348 0 0 0 .597-.076l.563-1.36zm6.985 0a.347.347 0 0 1 .368-.475l2.875.404a.345.345 0 0 1 .228.551l-1.745 2.317a.348.348 0 0 1-.597-.076l-.563-1.36z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.863 8.895C6.456 9.707 8 11.27 8 14.219m0 0v.813m0-.813c0-2.95 1.544-4.512 4.138-5.324M8 14.219V4.25m-1.468 0a.346.346 0 0 1-.298-.52l1.469-2.604a.346.346 0 0 1 .595 0l1.468 2.603a.346.346 0 0 1-.298.522zM4.508 7.338a.347.347 0 0 0-.369-.475l-2.875.404a.346.346 0 0 0-.228.551l1.745 2.317a.348.348 0 0 0 .597-.076l.563-1.36zm6.985 0a.347.347 0 0 1 .368-.475l2.875.404a.345.345 0 0 1 .228.551l-1.745 2.317a.348.348 0 0 1-.597-.076l-.563-1.36z"
  }));
});
export default SvgIconRouter;
export const raw = __webpack_public_path__ + "static/media/IconRouter.e80b2b3a37f6de524803dd091ea98df8.svg";